<div class="snackbar-outer">
  <div class="snackbar-left">
    <user-image [userId]="data.SenderId"
                [profileEnabled]="false"
                [forceShowProfileImage]="isGuardian()"
                [size]="'45px'">

    </user-image>
  </div>
  <div class="snackbar-middle"
       (click)="clickMiddle()">
    You have a new message{{data.HasAttachments ? ' and attachment' : ''}} from {{data.SenderUserName}}!
  </div>
  <div class="snackbar-right">
    <button type="button" class="btn btn-primary" (click)="dismiss()">Dismiss</button>
  </div>
</div>
